import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { Icon } from "../../icons";
import type { FileExplorerSelectOption } from "./shared";

/** Props Interface */
interface FileExplorerItemSelectProps {
	value: string;
	options: FileExplorerSelectOption[];
	onChange: (value: string) => void;
}

export function FileExplorerItemSelect({ value, options, onChange }: FileExplorerItemSelectProps) {
	/** Computed */
	const label = options.find((opt) => opt.value === value)?.label ?? value;

	/** Render */
	return (
		<Listbox
			value={value}
			onChange={onChange}
		>
			<ListboxButton className="w-full h-stack justify-between gap-2 text-sm text-primaryGray-800 dark:text-primaryGray-200 cursor-pointer outline-none bg-transparent absolute inset-0 px-3">
				<span className="truncate">{label}</span>
				<Icon name="ChevronDown" />
			</ListboxButton>
			<ListboxOptions
				anchor={{ gap: 5, to: "bottom" }}
				className="listbox-options w-[calc(var(--button-width))]!"
			>
				{options.map((opt) => (
					<ListboxOption
						key={opt.value}
						value={opt.value}
						className="listbox-option"
					>
						<p>{opt.label}</p>
						<div className="listbox-option-icon">
							<Icon name="Check" />
						</div>
					</ListboxOption>
				))}
			</ListboxOptions>
		</Listbox>
	);
}
